import "./ui/tokens.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initSentry, SentryErrorBoundary } from "./sentry";
import PreviewHarness from "./preview/PreviewHarness";
import { PREVIEW_FIXTURES } from "./preview/fixtures";
import { installPreviewFetch } from "./preview/installPreviewFetch";

// Start telemetry first so errors during startup are captured (no-op without a DSN).
initSentry();

const root = createRoot(document.getElementById("root")!);

// Dev-only renderer preview: ?preview=<type> shows one screen in isolation.
// In a production build import.meta.env.DEV is false, so previewType is null
// and the whole preview path (and its imports) is dead-code-eliminated.
const previewType = import.meta.env.DEV
  ? new URLSearchParams(window.location.search).get("preview")
  : null;

if (previewType !== null) {
  const fixture = PREVIEW_FIXTURES[previewType];
  if (fixture) installPreviewFetch(fixture);
  root.render(
    <StrictMode>
      <PreviewHarness type={previewType} />
    </StrictMode>,
  );
} else {
  root.render(
    <StrictMode>
      <SentryErrorBoundary
        fallback={
          <div
            role="alert"
            style={{
              maxWidth: 560,
              margin: "80px auto",
              padding: 24,
              fontFamily: "system-ui, sans-serif",
              textAlign: "center",
              color: "#212529",
            }}
          >
            <h1 style={{ fontSize: 20, marginBottom: 8 }}>Something went wrong</h1>
            <p style={{ fontSize: 15, lineHeight: 1.5 }}>
              The study hit an unexpected error. Please refresh the page to continue.
            </p>
          </div>
        }
      >
        <App />
      </SentryErrorBoundary>
    </StrictMode>,
  );
}
